module.exports = __webpack_public_path__ + "static/img/middle-kdy.28b2ba7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/middle-kdy.png
// module id = zEMm
// module chunks = 9